module.exports = __webpack_public_path__ + "img/847-947cf2.png";